import {getGtmCollections, getGtmTags, getGtmAvailability} from './gtmUtils';
import {
    GTM_ATTRIBUTE_PRODUCT_COLLECTIONS,
    GTM_ATTRIBUTE_PRODUCT_TAGS,
    GTM_SELECTOR_PRODUCT_AVAILABILITY,
    GTM_ATTRIBUTE_PRODUCT_SKU,
    GTM_ATTRIBUTE_PRODUCT_ID,
    GTM_ATTRIBUTE_PRODUCT_INDEX,
    GTM_ATTRIBUTE_PRODUCT_RATING,
    GTM_ATTRIBUTE_PRODUCT_REVIEWS,
    GTM_ATTRIBUTE_PRODUCT_PRICE,
    GTM_SELECTOR_IMAGE_URL,
    GTM_ATTRIBUTE_IMAGE_URL,
    GTM_ATTRIBUTE_PRODUCT_QUANTITY,
    GTM_SELECTOR_PRODUCT_QUANTITY,
    GTM_SELECTOR_PRODUCT_PRICE,
    GTM_ATTRIBUTE_PRODUCT_URL,
} from './gtmSelectors';

export const gtmProductClick = (productElement, title, listName) => {
    const analyticsData = JSON.parse(localStorage.getItem('analytics'));
    const taxRate = analyticsData?.tax_rate;
    const collections = getGtmCollections(productElement?.getAttribute(GTM_ATTRIBUTE_PRODUCT_COLLECTIONS));
    const tags = getGtmTags(productElement?.getAttribute(GTM_ATTRIBUTE_PRODUCT_TAGS));
    const availability = getGtmAvailability(productElement.querySelectorAll(GTM_SELECTOR_PRODUCT_AVAILABILITY));
    const url = productElement?.getAttribute(GTM_ATTRIBUTE_PRODUCT_URL);
    const sku = productElement?.getAttribute(GTM_ATTRIBUTE_PRODUCT_SKU);
    const id = productElement?.getAttribute(GTM_ATTRIBUTE_PRODUCT_ID);
    const index = Number(productElement?.getAttribute(GTM_ATTRIBUTE_PRODUCT_INDEX));
    const rating = Number(productElement?.getAttribute(GTM_ATTRIBUTE_PRODUCT_RATING));
    const reviews = Number(productElement?.getAttribute(GTM_ATTRIBUTE_PRODUCT_REVIEWS));
    const price = Number(
        productElement.querySelector(GTM_SELECTOR_PRODUCT_PRICE)?.getAttribute(GTM_ATTRIBUTE_PRODUCT_PRICE),
    ) / 100;
    const image = productElement.querySelector(GTM_SELECTOR_IMAGE_URL)?.getAttribute(GTM_ATTRIBUTE_IMAGE_URL) ?? '';
    const quantity = Number(
        productElement.querySelector(GTM_SELECTOR_PRODUCT_QUANTITY)?.getAttribute(GTM_ATTRIBUTE_PRODUCT_QUANTITY),
    );

    window.dataLayer.push({
        'event': 'ec.product_click',
        'ecommerce': {
            'listName': listName,
            'products': [{
                'id': id,
                'sku': sku,
                'name': title,
                'priceWithoutVat': price - price * taxRate,
                'vatAmount': price * taxRate,
                'priceWithTax': price,
                'brand': 'Expedo',
                'categories': collections,
                'url': `${window.location.origin}${url}`,
                'imageUrl': image,
                'availability': availability,
                'flags': tags,
                'quantity': quantity,
                'listIndex': index + 1,
                'rating': rating,
                'reviews': reviews,
                'productType': 'product',
            }],
        },
        '_clear': true,
    });
};
